import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getRandomColor } from '@/lib';
import clsx from 'clsx';

export interface AvatarItem {
	url: string | undefined;
	initials?: string;
}

interface Props {
	options: AvatarItem[];
	max?: number; // cuántos avatares mostrar antes del +n
	size?: 'sm' | 'md' | 'lg' | 'base';
	overlap?: 'sm' | 'md' | 'lg' | 'xl';
	className?: string;
}

export const AvatarGroup: React.FC<Props> = ({
	options,
	max = 4,
	size = 'sm',
	overlap = 'md',
	className,
}) => {
	const displayedAvatars = options.slice(0, max);
	const remaining = options.length - max;
	const sizeClasses = {
		sm: 'w-7 h-7 text-xs',
		md: 'w-9 h-9 text-sm',
		base: 'w-10 h-10 text-sm',
		lg: 'w-12 h-12 text-base',
	}[size];
	const overlapMap: Record<NonNullable<Props['overlap']>, string> = {
		sm: '-space-x-2',
		md: '-space-x-3',
		lg: '-space-x-4',
		xl: '-space-x-5',
	};
	const overlapClasses = overlapMap[overlap];

	return (
		<div className={clsx('flex items-center', overlapClasses, className)}>
			{displayedAvatars.map(({ url, initials }, index) => (
				<Avatar
					key={index}
					className={`
            ${sizeClasses}
            border-2 border-white
            shadow-sm bg-white
            transition-transform hover:z-10 hover:scale-110
          `}
					style={{
						backgroundColor: getRandomColor(
							initials?.[0] || 'N',
							initials?.[1] || 'N'
						),
					}}
				>
					<AvatarImage src={url} alt="" />
					<AvatarFallback className="text-muted-foreground bg-muted">
						{initials ?? '??'}
					</AvatarFallback>
				</Avatar>
			))}

			{remaining > 0 && (
				<div
					className={`
            ${sizeClasses}
            flex items-center justify-center
            rounded-full
            bg-muted
            text-muted-foreground
            text-xs font-medium
            ring-2 ring-background
            border-2 border-white
            shadow-sm

          `}
				>
					+{remaining}
				</div>
			)}
		</div>
	);
};
